import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { afterItems, beforeItems } from '../../data/content';
export function BeforeAfterSection() {
  return <section aria-labelledby="compare-heading" className="bg-brand-oatmeal px-5 py-16 lg:px-8 lg:py-24" data-id="element-46" data-mp="1xotspxz95xp4">
      <div className="mx-auto max-w-5xl" data-id="element-47" data-mp="22nohdgjwigh5">
        <SectionHeading id="compare-heading" title="Imaginez préparer votre prochain cours sans partir d’une page blanche." data-id="element-48" data-mp="22qsrsvnym8g9" />

        <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-49" data-mp="1srlgsf4p6pwb">
          <div className="rounded-[20px] bg-brand-ivory/70 p-7 sm:p-9" data-id="element-50" data-mp="1ezngmtsys4ca">
            <h3 className="font-body text-[12px] font-bold uppercase tracking-[0.16em] text-brand-charcoal/55" data-id="element-51" data-mp="1exar9vkvmrp7">Avant</h3>
            <ul className="mt-6 space-y-3.5" role="list" data-id="element-52" data-mp="151hecb38ww6w">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-snug text-brand-charcoal/60" data-id="element-53" data-mp="1a010oclr49zs">
                  <XIcon className="mt-0.5 h-4 w-4 flex-none text-[#B5655E]" strokeWidth={2.25} aria-hidden="true" data-id="element-54" data-mp="276xenvxmsu87" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-[20px] border-2 border-brand-cta/40 bg-white p-7 shadow-[0_30px_60px_-40px_rgba(30,82,54,0.55)] sm:p-9" data-id="element-55" data-mp="2g7demvf61j8b">
            <h3 className="font-body text-[12px] font-bold uppercase tracking-[0.16em] text-brand-cta" data-id="element-56" data-mp="2c4p4mkepu69r">
              Avec Nail Educator Ready™
            </h3>
            <ul className="mt-6 space-y-3.5" role="list" data-id="element-57" data-mp="1jj72zojttqkj">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3 text-[15px] font-medium leading-snug text-brand-charcoal" data-id="element-58" data-mp="1xakjetmfu8bc">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand-cta" strokeWidth={2.5} aria-hidden="true" data-id="element-59" data-mp="1shj2kg2o7yp4" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-14 max-w-3xl text-center font-display text-[2rem] font-bold leading-tight text-brand-charcoal sm:text-[2.6rem]" data-id="element-60" data-mp="2zwed9yyfqtks">
          Moins de temps à préparer. <Accent data-id="element-61" data-mp="34tod88jganmv">Plus de structure pour enseigner.</Accent>
        </p>
      </div>
    </section>;
}